/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientIdentificationRequest as AgentApiContractClientIdentificationRequest } from '../../models/AgentApi/Contract/client-identification-request';
import { ClientIdentificationResponse as AgentApiContractClientIdentificationResponse } from '../../models/AgentApi/Contract/client-identification-response';

export interface ApiAgentClientIdentificationPost$Params {

/**
 * ui language code
 */
  lang?: string;
      body?: AgentApiContractClientIdentificationRequest
}

export function apiAgentClientIdentificationPost(http: HttpClient, rootUrl: string, params?: ApiAgentClientIdentificationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractClientIdentificationResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAgentClientIdentificationPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractClientIdentificationResponse>;
    })
  );
}

apiAgentClientIdentificationPost.PATH = '/api/Agent/ClientIdentification';
